import React from 'react';
import { Container, SectionHeader, Card, Button } from '../ui';

// Honest replacement for anonymous testimonials. No fabricated quotes.
const References = ({ onRequestDemo }) => (
  <section className="bg-ink-50 py-16 sm:py-24">
    <Container size="md">
      <SectionHeader
        align="center"
        eyebrow="References"
        title="Real references, coming soon"
        subtitle="We're onboarding our first Rio Grande Valley district partners."
      />
      <Card className="mt-8 p-8 sm:p-10 text-center">
        <div className="text-3xl mb-3">🤝</div>
        <p className="text-ink-700 max-w-xl mx-auto leading-relaxed">
          We'd rather show you a real district than a made-up quote. As we launch with our first
          partners, their results and references will appear here. Want to be one of them?
        </p>
        <Button onClick={onRequestDemo} className="mt-6" size="lg">Become a founding district</Button>
      </Card>
    </Container>
  </section>
);

export default References;
